import { EPlacingType } from '../../types/reducers/publishTerms';
import { actionGenerator, IReduxAction } from '../../utils/actions';

export const SELECT_PLACING_TYPE = 'PUBLISH_TERMS :: SELECT_PLACING_TYPE';

export type TSelectPlacingTypeAction = IReduxAction<typeof SELECT_PLACING_TYPE, EPlacingType>;

export const selectPlacingType = actionGenerator<typeof SELECT_PLACING_TYPE, EPlacingType>(SELECT_PLACING_TYPE);
